(function (global, factory) {
  if ('function' == typeof define && define.amd) define(['module', 'exports', 'lodash/includes'], factory);else if ('undefined' != typeof exports) factory(module, exports, require('lodash/includes'));else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.includes), global.check_status = mod.exports;
  }
})(this, function (module, exports, _includes2) {
  'use strict';

  Object.defineProperty(exports, '__esModule', {
    value: !0
  }), exports.default = function (status, readyState) {
    return (0, _includes3.default)(success_status, status) || 4 !== readyState ? 4 === readyState ? 1 : 0 : -1;
  };

  var _includes3 = function (obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }(_includes2),
      success_status = [200, 201, 204];

  module.exports = exports['default'];
});